module.exports = __webpack_public_path__ + "static/media/clasesUX-4.8a9005e8.jpg";